/**
 * Typed wrappers for /api/_debug/*. The endpoints exist only when the api
 * boots with DEBUG_TOOLS=1; the SPA gates the menu on `me.debugTools` so
 * these wrappers are never invoked in production.
 *
 * Mirrors the costs-api.ts pattern: throw on non-2xx so call sites can
 * `try/catch` for the toast layer.
 */
import { apiFetch } from "./api";

export interface Savepoint {
  id: string;
  createdAt: number;
}

async function ok<T>(res: Response): Promise<T> {
  if (!res.ok) {
    const err = new Error(`api ${res.status}`) as Error & { status: number };
    err.status = res.status;
    throw err;
  }
  return (await res.json()) as T;
}

export async function resetDebugDb(mode: "base" | "demo"): Promise<{ status: string }> {
  const res = await apiFetch("/api/_debug/reset", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ mode }),
  });
  return ok<{ status: string }>(res);
}

export async function listSavepoints(): Promise<Savepoint[]> {
  const res = await apiFetch("/api/_debug/savepoints");
  return ok<Savepoint[]>(res);
}

export async function createSavepoint(): Promise<Savepoint> {
  const res = await apiFetch("/api/_debug/savepoints", { method: "POST" });
  return ok<Savepoint>(res);
}

export async function restoreSavepoint(id: string): Promise<{ status: string }> {
  const res = await apiFetch(`/api/_debug/savepoints/${encodeURIComponent(id)}/restore`, {
    method: "POST",
  });
  return ok<{ status: string }>(res);
}
